import { Badge } from "@/components/ui/badge";

export const StepsBlock = ({ steps }) => (
  <section className="section-padding bg-white" data-testid="steps-block">
    <div className="container-custom max-w-3xl">
      <div className="text-center mb-10">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">Méthode pas à pas</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900">Les étapes en détail</h2>
      </div>
      <ol className="space-y-6">
        {steps.map((step, idx) => (
          <li key={step.title} className="flex gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600 text-white flex items-center justify-center font-bold">
              {idx + 1}
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-lg text-slate-900 mb-2">{step.title}</h3>
              <p className="text-slate-700 leading-relaxed">{step.content}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
